import { useContext } from 'react'
import { ContextoTemaReact } from './contexto'

export function useTema() {
  const ctx = useContext(ContextoTemaReact)
  if (!ctx) throw new Error('useTema exige ProvedorTema acima na árvore.')
  return ctx
}
